import { render, staticRenderFns } from "./NotificationEditModal.vue?vue&type=template&id=24053556&scoped=true&"
import script from "./NotificationEditModal.vue?vue&type=script&lang=js&"
export * from "./NotificationEditModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEditModal.vue?vue&type=style&index=0&id=24053556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24053556",
  null
  
)

export default component.exports